import { DateRangeName } from 'dateRanges'
import { t } from 'translations'

export type CompareToType = 'prevPeriod' | 'prevYear' | 'custom'

export type DateRangeType = 'sale' | 'visit' | 'created_at' | 'event_date' | 'expires_at'

export interface Option {
    name: string
    value: CompareToType | DateRangeName
}

export interface PickerRange {
    from: Date
    to: Date
}

export interface CompareRangeQuery {
    compareRangeFrom: string | null
    compareRangeTo: string | null
    compareToPeriod: CompareToType | null
}

export interface DateRangeOption {
    name: string;
    value: string;
}

// A function so the labels are translated when they are shown, not when this module loads.
export const getDateRangeOptions = (): DateRangeOption[] => [
    { name: t('uiComponents.popups.dateRangePicker.dateCreated'), value: 'created_at' },
    { name: t('uiComponents.popups.dateRangePicker.dateOfVisit'), value: 'event_date' },
    { name: t('uiComponents.popups.dateRangePicker.paymentDeadline'), value: 'expires_at' },
]
